import { SubscriptionTier } from '@/types';

// Re-export from the new component for backward compatibility
export const ATTACK_SURFACE_OPTIONS = [
  {
    label: 'External',
    value: 'external',
  },
  {
    label: 'Web',
    value: 'applications',
  },
  {
    label: 'Code',
    value: 'code',
  },
  {
    label: 'Internal',
    value: 'internal',
  },
  {
    label: 'Cloud',
    value: 'cloud',
  },
  {
    label: 'Users',
    value: 'users',
  },
  {
    label: 'Device',
    value: 'device',
  },
];

export const SUBSCRIPTION_TIERS: SubscriptionTier[] = [
  {
    id: 'freemium',
    displayName: 'Freemium',
    features: {
      'Product Modules': {
        'Attack Surface Management': true,
        'Unified Vulnerability Management': true,
        'Continuous Penetration Testing': false,
        'Cyber Threat Intelligence': false,
        'Application Security Testing': false,
        'Adversary Emulation Validation': false,
      },
      'Customer Success': {
        'Executive Sponsor Quarterly Reviews': false,
        'Annual Penetration Test Report': false,
        'Email Communication': false,
        'Monthly Calls': false,
        'Vulnerability Read-Outs': false,
        'Chat Access': false,
      },
    },
  },
  {
    id: 'foundational',
    displayName: 'Foundational',
    features: {
      'Product Modules': {
        'Attack Surface Management': true,
        'Unified Vulnerability Management': true,
        'Continuous Penetration Testing': true,
        'Cyber Threat Intelligence': true,
        'Application Security Testing': false,
        'Adversary Emulation Validation': false,
      },
      'Customer Success': {
        'Executive Sponsor Quarterly Reviews': true,
        'Annual Penetration Test Report': true,
        'Email Communication': true,
        'Monthly Calls': false,
        'Vulnerability Read-Outs': false,
        'Chat Access': false,
      },
    },
  },
  {
    id: 'professional',
    displayName: 'Professional',
    features: {
      'Product Modules': {
        'Attack Surface Management': true,
        'Unified Vulnerability Management': true,
        'Continuous Penetration Testing': true,
        'Cyber Threat Intelligence': true,
        'Application Security Testing': true,
        'Adversary Emulation Validation': false,
      },
      'Customer Success': {
        'Executive Sponsor Quarterly Reviews': true,
        'Annual Penetration Test Report': true,
        'Email Communication': true,
        'Monthly Calls': true,
        'Critical & High Severity Read-Outs': true,
        'Chat Access': false,
      },
    },
  },
  {
    id: 'ultimate',
    displayName: 'Ultimate',
    features: {
      'Product Modules': {
        'Attack Surface Management': true,
        'Unified Vulnerability Management': true,
        'Continuous Penetration Testing': true,
        'Cyber Threat Intelligence': true,
        'Application Security Testing': true,
        'Adversary Emulation Validation': true,
      },
      'Customer Success': {
        'Executive Sponsor Quarterly Business Reviews': true,
        'Annual Penetration Test Report': true,
        'Email Communication': true,
        'Monthly Calls': true,
        'All Severity Vulnerability Read-Outs': true,
        'Chat Access': true,
      },
    },
  },
];

export const NO_OF_ASSETS_OPTIONS = [
  { value: 5000, label: '≤ 5k' },
  { value: 10000, label: '≤ 10k' },
  { value: 20000, label: '≤ 20k' },
  { value: 50000, label: '≤ 50k' },
  { value: 100000, label: '≤ 100k' },
  { value: 300000, label: '≤ 300k' },
];

export const FREQUENCY_OPTIONS = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];
